import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { environnement } from '@/config/env';

let client: SupabaseClient | null = null;

/** Le client Supabase unique. N'existe pas en mode démo. */
export function supabase(): SupabaseClient {
  if (client) return client;
  if (!environnement.ok || environnement.env.mode !== 'supabase') {
    throw new Error('Supabase n’est pas configuré : voir .env.example.');
  }
  client = createClient(environnement.env.supabaseUrl, environnement.env.supabaseAnonKey, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  });
  return client;
}

/** Vrai quand l'application tourne sur les données fictives de `npm run dev:demo`. */
export function enModeDemo(): boolean {
  return environnement.ok && environnement.env.mode === 'demo';
}
